import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { RangePresetKey } from '../custom-header/custom-range-panel/custom-range-panel.component';

@Injectable()
export class DateRangePickerService {
    public applyDisabled = new BehaviorSubject(false);
    public customPresets: RangePresetKey[] = [];
}
